<main class="bg-black text-white min-h-screen overflow-x-hidden">
  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="max-w-3xl">
        <a routerLink="/solutions/consumers" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back to For Consumers
        </a>
        <h1 class="hero-col font-black mb-5" data-aos="fade-up" data-aos-delay="100">
          Varroc Miles <span class="text-varroc-accent">Rewards</span> Program
        </h1>
        <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-2xl" data-aos="fade-up" data-aos-delay="200">
          Earn miles on every kilometre, every safe driving moment, and every referral then redeem at fuel stations, service centres, and 500+ partner rewards.
        </p>
        <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
          <a routerLink="/store/product" class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all">Start Earning Now</a>
          <a routerLink="/products/connectiq/miles" class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all">Varroc Miles Platform</a>
        </div>
      </div>
    </div>
  </section>
  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>
  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">
    <section id="overview" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">How It Works</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Drive. Earn. Redeem.</h2>
        <div class="flex flex-wrap gap-3 justify-start mt-8">
          <div *ngFor="let step of earnSteps; let i = index" class="feature-card text-center p-5 min-w-[180px]" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 80).toString()">
            <div class="text-varroc-accent font-black text-2xl mb-2">0{{ i + 1 }}</div>
            <div class="text-white text-sm font-semibold">{{ step }}</div>
          </div>
        </div>
      </div>
    </section>
    <div class="accent-divider"></div>
    <section id="features" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Features</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Rewards Built Around You</h2>
      </div>
      <div class="grid md:grid-cols-3 gap-6">
        <div *ngFor="let f of features; let i = index" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 80).toString()">
          <div class="w-11 h-11 bg-varroc-accent/15 rounded-xl flex items-center justify-center mb-4">
            <img *ngIf="f.iconImage; else defaultFeatureIcon" [src]="f.iconImage" [alt]="f.title + ' icon'" class="w-6 h-6 object-contain" />
            <ng-template #defaultFeatureIcon>
              <i class='bx icon-gradient text-xl' [class]="f.icon"></i>
            </ng-template>
          </div>
          <h3 class="text-white font-bold mb-2">{{ f.title }}</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ f.desc }}</p>
        </div>
      </div>
    </section>
    <!-- <div class="accent-divider"></div>
    <section id="howto" class="section-anchor">
      <div class="feature-card p-10 text-center" data-aos="fade-up">
        <p class="text-varroc-text-gray text-lg mb-6">Start earning miles on your next drive.</p>
        <a routerLink="/store/product" class="inline-block bg-varroc-accent text-white font-bold px-10 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all">Get Your Device & Start Earning</a>
      </div>
    </section> -->
  </div>
</main>
